'use strict';

import { Helper } from "../helpers/Helper.js";

export class DonationVariation {
	constructor() {
		this.#addEventListeners();
	}

	#addEventListeners() {
		const categoryWrappers = document.querySelectorAll('.category-wrapper');
		const selectFields = document.querySelectorAll('select[id^="levcharity_selected_category_name_"]');
		categoryWrappers.forEach((wrapper) => {
			const inputField = wrapper.querySelector('input[id^="levcharity_variation_category_"]');
			const hiddenLabelInput = wrapper.querySelector('input[id^="variation_category_label_"]');
			if (inputField && selectFields.length > 0) {
				inputField.addEventListener('keypress', (event) => this.#handleKeyPress(event, inputField, selectFields, hiddenLabelInput));
			}

			selectFields.forEach(selectField => {
				const correspondingWrapper = selectField.closest('.category-wrapper');
				const correspondingHiddenLabelInput = correspondingWrapper.querySelector('input[id^="variation_category_label_"]');
				correspondingHiddenLabelInput.value = selectField.options[selectField.selectedIndex].text;
				selectField.addEventListener('change', () => {
					correspondingHiddenLabelInput.value = selectField.options[selectField.selectedIndex].text;
				});
			});
		});
		const donationVariationContainer = document.querySelector(
			".levcharity_input_wrapper.donation_variations.donation-variations-form"
		);

		if (!donationVariationContainer) return;

		const donationVariationCheckbox =
			donationVariationContainer.querySelectorAll("input.donation_variation_checkbox");

		Array.from(donationVariationCheckbox).forEach(elem => {
			elem.addEventListener('change', function (event) {
				const group = event.target.closest('.form-field.variation_checkbox_form_field');
				if (!group) return;

				const variationQuantityInput = group.querySelector('.variation_quantity input');
				if (!variationQuantityInput) return;

				const quantity = +variationQuantityInput.value || 0;

				if (quantity === 0 && event.target.checked) {
					const addBtn = group.querySelector('.variation_quantity .add');
					if (addBtn) addBtn.click();
				} else if (quantity > 0 && !event.target.checked) {
					const valueEl = group.querySelector('.variation_quantity .value');
					if (valueEl) valueEl.innerText = 0;
					variationQuantityInput.value = 0;
				}
			});
		});


	}

	#handleKeyPress(event, inputField, selectFields, hiddenLabelInput) {
		if (event.key === 'Enter') {
			event.preventDefault();
			const newCategoryValue = Helper.slugify(inputField.value.trim()) || '-';
			const newCategoryName = inputField.value.trim();
			if (newCategoryName !== '') {
				selectFields.forEach(selectField => {
					// Remove existing options with the same value
					Array.from(selectField.options).forEach(option => {
						if (option.value === newCategoryValue) {
							selectField.removeChild(option);
						}
					});

					// Create new option and add it to the select field
					const option = document.createElement('option');
					option.value = newCategoryValue;
					option.text = newCategoryName;

					// Append the new option without setting it as selected
					selectField.appendChild(option);
				});

				inputField.value = '';
			}
		}
	}
}
